import React from 'react';
import { usePage } from '@inertiajs/inertia-react';
import MainMenuItem from './MainMenuItem';
import { can } from '../utils';

export default ({ className }) => {
     const { auth, app } = usePage().props;
     return (
          <div className={className}>
               <MainMenuItem text="Dashboard" link="home" icon="dashboard" notification={false} />
               <MainMenuItem text="Student" link="student.index" icon="users" notification={false} />
               {/* <MainMenuItem text="Catalog" link="catalog.index" icon="book-open" notification={false} /> */}
               <MainMenuItem text="Cart" link="cart.get" icon="shopping-cart" notification={app.cart} />
               <MainMenuItem text="Purchase History" link="order.index" icon="money" notification={false} />
               <MainMenuItem text="Items Purchased" link="item.index" icon="box" notification={false} />
               <MainMenuItem text="Return to site" link="site" icon="return" notification={false} />
          </div>
     );
};
